/* RESPONSIBLE TEAM: team-fin-voice */
import Model, { attr } from '@ember-data/model';

export type TranslationType = 'phonetic' | 'ipa' | 'cmu';

export interface LanguageOverride {
  languageCode: string;
  languageName: string;
  pronunciation: string;
  translationType: TranslationType;
}

export default class FinVoicePronunciation extends Model {
  @attr('string') declare term: string;
  @attr('string') declare defaultPronunciation: string;
  @attr('string') declare defaultTranslationType: TranslationType;
  @attr({ defaultValue: () => [] }) declare languageOverrides: LanguageOverride[];
  @attr('date') declare createdAt: Date;
  @attr('date') declare updatedAt: Date;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'fin-voice/pronunciation': FinVoicePronunciation;
  }
}
